import React, { Component, useState } from "react";
import "./Header.css"
import logo from './logo.svg';
import {
  Link
} from "react-router-dom";

function Navbar() {
    const [isNavExpanded, setIsNavExpanded] = useState(false)
    return (
      <nav className="navigation">
        <img src={logo} className="brand-logo" alt="logo" />
        <a href="/" className="brand-name">
          Testuj.pl
        <i ></i>
        </a>
        <button className="hamburger"
                onClick={() => {
                    setIsNavExpanded(!isNavExpanded);
                  }}>
          {/* icon from heroicons.com */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
            className={isNavExpanded ? "navigation-menu expanded" : "navigation-menu"}
        >
            <ul>
            <li>
                <Link to="/">Home</Link>
            </li>
            <li>
                <Link to="/about">About</Link>
            </li>
            <li>
                <Link to="/contact">Contact</Link>
            </li>
            </ul>
        </div>
      </nav>
    );
}

export default class Header extends Component {
    render() {
        return (
            <Navbar />
        )
    }
}